<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Financial Advisors</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Enhance your visibility and credibility as a financial advisor with LocalScale, your trusted partner in targeted advertising</p>
                        <p>In the world of financial services, trust and reputation are everything.</p>
                        <p>That's why LocalScale specializes in helping financial advisors like you strengthen your local presence and reach potential clients effectively.</p>
                        <p>Whether you specialize in retirement planning, wealth management, or investment advisory services, our precision-targeted ad network allows you to connect with individuals in your community who are actively seeking financial guidance.</p>
                        <p>By leveraging LocalScale, you can ensure that your expertise and personalized approach to financial planning resonate with the right audience, fostering trust and driving meaningful client engagements.</p>
                        <p>Let us help you build lasting relationships and grow your advisory practice with confidence.</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-financial.png" alt="Financial">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote">“LocalScale has been instrumental in expanding our client base and reinforcing our reputation as trusted financial advisors in the community. Their targeted advertising solutions helped us connect with individuals who were actively seeking financial guidance, resulting in a noticeable increase in client inquiries. Thanks to LocalScale, we've been able to grow our practice and continue providing personalized financial solutions to our clients with confidence.”</h3>
                    <p class="testimonial-customer">– Michael Thompson, Senior Financial Advisor at Thompson Wealth Management</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>

    </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import Plans from "../components/Plans";

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer, Plans
    }
}
</script>

<style>
body {
    font-family: Inter, sans-serif;
    background-color: #fff;
}
p {
    color: black;
    margin: 10px;
    font-size: 16px;
}
h2 {
    text-align: center;
}
a {
    text-decoration: none;
    color: #1f1f1f
}
</style>
